export enum DocumentStatusExecutionStatus {
    NA,
    Accepted,
    Executed,
    Offered,
}

export const DocumentStatusExecutionStatusOptions = {
    [DocumentStatusExecutionStatus.NA]: '',
    [DocumentStatusExecutionStatus.Accepted]: 'Accepted',
    [DocumentStatusExecutionStatus.Executed]: 'Executed',
    [DocumentStatusExecutionStatus.Offered]: 'Offered',
};
